import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import DateField from 'components/DateField';
import moment from 'moment';
import { Button } from '@ontruck/orc';

const t = {
  change_date: 'Change date',
  cancel: 'Cancel',
  empty_date: 'Not date registered yet.',
};

const InlineDateUpdate = ({ className, currentDate, handleSave }) => {
  const [date, setDate] = useState(currentDate);
  const [isEditingDate, setIsEditingDate] = useState(false);

  const toggleDateEdit = useCallback(
    (e) => {
      e.stopPropagation();
      setIsEditingDate(!isEditingDate);
    },
    [isEditingDate]
  );

  const handleSaveDate = useCallback(() => {
    handleSave(date);
    setIsEditingDate(false);
  }, [date, handleSave]);

  if (isEditingDate) {
    return (
      <div
        className={className}
        onFocus={(e) => {
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="inline-date_update__edit" data-testid="editDateField">
          <DateField
            className="inline-date_update__date-field"
            onChange={(value) => {
              const formatValue = moment(value).format('YYYY-MM-DD');
              setDate(formatValue);
            }}
            size="S"
            value={date}
            inputClass="inline-date_update__date-input"
          />
          <Button
            onClick={handleSaveDate}
            skin="primary"
            size="S"
            text={t.change_date}
            data-testid="editDateSubmitBtn"
          />
          <Button
            onClick={toggleDateEdit}
            nude
            skin="secondary"
            size="S"
            text={t.cancel}
            data-testid="editDateCancelBtn"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="inline-date_update">
        <div
          className="inline-date_update__current-date"
          data-testid="currentDate"
          onClick={toggleDateEdit}
        >
          {currentDate && <span>{date}</span>}
          {!currentDate && <span className="inline-date_update__empty">{t.empty_date}</span>}
        </div>
      </div>
    </div>
  );
};

InlineDateUpdate.propTypes = {
  className: PropTypes.string,
  currentDate: PropTypes.string.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default InlineDateUpdate;
